import { OrderView } from '../../../../orders/order';
import { SharedDocument } from '../../../../documents/sharedDocument';
import { FormDropdown as Dropdown } from '@ami/react/core';
import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from '@ami/react/core';
import CustomOrderDocument from '../../../../documents/customOrderDocument';

export default class AddSharedDocumentModalComponent extends React.Component {
  static propTypes = {
    order: PropTypes.instanceOf(OrderView).isRequired,
    onDocumentCreated: PropTypes.func.isRequired,
    showModal: PropTypes.bool.isRequired,
    hideModal: PropTypes.func.isRequired,
  };

  state = {
    items: [],
    selectedSharedDocumentId: null,
    submitting: false,
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.showModal && this.props.showModal) {
      this.setState({
        items: [],
      });
      SharedDocument.search().then((items) => this.setState({ items: items }));
    }
  }

  save = () => {
    this.setState({ submitting: true });
    const savePromise = CustomOrderDocument.createShared(
      this.props.order.id,
      this.state.selectedSharedDocumentId
    );
    savePromise
      .then(() => {
        this.props.onDocumentCreated();
        this.hide();
        this.setState({ selectedSharedDocumentId: null });
      })
      .finally(() => this.setState({ submitting: false }));
  };

  hide = () => this.props.hideModal();

  render() {
    const addedSharedDocuments = this.props.order.documents.filter(
      (x) => x.type === 'Shared'
    );
    const remainingSharedDocuments = this.state.items.filter(
      (x) => !addedSharedDocuments.some((a) => a.id === x.sharedDocumentId)
    );
    return (
      <Modal
        title="Add Shared Document"
        show={this.props.showModal}
        showCancel={true}
        onOk={this.save}
        onCancel={this.hide}
        onShowUpdated={(showModal) => {
          if (!showModal) this.hide();
        }}
        submitting={this.state.submitting}
        closeOnOk={false}
      >
        <div className="row order-document-form">
          <div className="col">
            <Dropdown
              placeholder="None"
              isClearable={true}
              label="Shared Document"
              items={remainingSharedDocuments.map((x) => ({
                id: x.sharedDocumentId,
                label: x.sharedDocumentName,
              }))}
              selectedId={this.state.selectedSharedDocumentId}
              onChange={(selectedSharedDocumentId) =>
                this.setState({ selectedSharedDocumentId })
              }
            />
          </div>
        </div>
      </Modal>
    );
  }
}
